var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("div", { staticClass: "header-left" }, [
      _c(
        "h3",
        { staticClass: "title" },
        [
          _c(
            "router-link",
            { staticClass: "index-link", attrs: { to: "/welcome" } },
            [_vm._v("前端配置中心")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "header-right" },
      [
        _c(
          "el-dropdown",
          { staticClass: "user-info", on: { command: _vm.handleCommand } },
          [
            _c("span", { staticClass: "el-dropdown-link" }, [
              _vm.userInfo.avatar !== ""
                ? _c("img", {
                    staticClass: "avatar",
                    attrs: { src: _vm.userInfo.avatar }
                  })
                : _c("img", {
                    staticClass: "avatar",
                    attrs: {
                      src: require("../../assets/img/default_avatar.jpg")
                    }
                  }),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(
                  "\n                    " + _vm._s(_vm.userInfo.realname)
                ),
                _c("i", { staticClass: "el-icon-caret-bottom el-icon--right" })
              ])
            ]),
            _vm._v(" "),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c("el-dropdown-item", { attrs: { command: "logout" } }, [
                  _c("i", { staticClass: "el-icon el-icon-my-zhuxiao" }),
                  _vm._v(" 注销\n                ")
                ]),
                _vm._v(" "),
                _c("el-dropdown-item", { attrs: { command: "userlogout" } }, [
                  _c("i", { staticClass: "el-icon el-icon-my-quanxian" }),
                  _vm._v(" 跳转到登录页\n                ")
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26464914", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26464914","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/containWraper/head.vue
// module id = 1214
// module chunks = 7